module.exports = __webpack_public_path__ + "img/menus-black.d00e9fdc.svg";